import React, { FC, useEffect, useRef } from "react";
import {
	motion,
	useMotionValue,
	useSpring,
	AnimatePresence,
} from "framer-motion";
import classes from "./ImageAnimation.module.scss";
import { useMatchMedia } from "../../hooks/useMatchMedia";

export const ImageAnimation: FC = () => {
	const { isTablet, isMobile }: any = useMatchMedia();
	const containerRef = useRef<HTMLDivElement>(null);
	const imageRef = useRef<HTMLImageElement>(null);
	const x = useMotionValue(0);
	const y = useMotionValue(0);
	const bounceConfig = { type: "spring", stiffness: 100, damping: 50 };

	useEffect(() => {
		const container = containerRef.current;
		const image = imageRef.current;

		if (!container || !image) {
			return;
		}

		const containerBounds = container.getBoundingClientRect();

		const handleMouseMove = (event: MouseEvent) => {
			const mouseX = event.clientX;
			const mouseY = event.clientY;
			const containerLeft = containerBounds.left;
			const containerRight = containerBounds.right;
			const containerTop = containerBounds.top;
			const containerBottom = containerBounds.bottom;
			const imageWidth = image.clientWidth;
			const imageHeight = image.clientHeight;

			let newX = mouseX - containerLeft - imageWidth / 2;
			let newY = mouseY - containerTop - imageHeight / 2;
			newY -= window.pageYOffset;

			if (newX < 0) {
				newX = 0;
			} else if (newX > containerRight - containerLeft - imageWidth) {
				newX = containerRight - containerLeft - imageWidth;
			}

			if (newY < 0) {
				newY = 0;
			} else if (newY > containerBottom - containerTop - imageHeight) {
				newY = containerBottom - containerTop - imageHeight;
			}

			x.set(newX);
			y.set(newY);
		};

		document.addEventListener("mousemove", handleMouseMove);

		return () => {
			document.removeEventListener("mousemove", handleMouseMove);
		};
	}, []);

	const springX = useSpring(x, bounceConfig);
	const springY = useSpring(y, bounceConfig);

	return (
		<>
			{!isTablet && !isMobile ? (
				<div className={classes.container} ref={containerRef}>
					<div className={classes.wrapper}>
						<motion.img
							className={classes.gamepad1}
							src="images/gamepad-2.png"
							loading="eager"
							alt="Image"
							animate={{
								y: [-2, 2, -2],
							}}
							transition={{
								duration: 5,
								repeat: Infinity,
								repeatType: "reverse",
							}}
						/>
						<AnimatePresence>
							<motion.img
								className={classes.image}
								ref={imageRef}
								src="images/gamepad-1.png"
								loading="eager"
								alt="Image"
								style={{ x: springX, y: springY }}
								drag
								dragConstraints={containerRef}
								dragElastic={0.5}
								dragMomentum={false}
							/>
						</AnimatePresence>
						<motion.img
							className={classes.gamepad3}
							loading="eager"
							src="images/gamepad-3.png"
							alt="Image"
							animate={{
								y: [-15, 15, -15],
							}}
							transition={{
								duration: 5,
								repeat: Infinity,
								repeatType: "reverse",
							}}
						/>
					</div>
				</div>
			) : (
				<div className={classes.wrapper}>
					<div className={classes.content}>
						<motion.img
							className={classes.image}
							src="images/gamepad-2.png"
							alt=""
							animate={{
								y: [-10, 10, -10],
							}}
							transition={{
								duration: 5,
								repeat: Infinity,
								repeatType: "reverse",
							}}
						/>
						<motion.img
							className={classes.image}
							src="images/gamepad-1.png"
							alt=""
							animate={{
								y: [-10, 10, -10],
							}}
							transition={{
								duration: 5,
								repeat: Infinity,
								repeatType: "reverse",
							}}
						/>

						<motion.img
							className={classes.image}
							src="images/gamepad-4.png"
							alt=""
							animate={{
								y: [-10, 10, -10],
							}}
							transition={{
								duration: 5,
								repeat: Infinity,
								repeatType: "reverse",
							}}
						/>
					</div>
				</div>
			)}
		</>
	);
};
